import { Pipe, PipeTransform } from '@angular/core';
import { getUserColor } from 'src/app/lib/create-avatar';
import { StateService } from 'src/app/services/state.service';

@Pipe({
  name: 'userColor',
  standalone: true,
})
export class UserColorPipe implements PipeTransform {
  constructor(private state: StateService) {}

  async transform(
    user: {
      first_name?: string;
      last_name?: string;
      name?: string;
      avatar_url?: string;
      id?: string;
      anonymous_id?: string;
    },
    usePreGuestAnonymousGuestId?: boolean
  ): Promise<string> {
    if (!user) {
      if (usePreGuestAnonymousGuestId && this.state.preGuestAnonymousId) {
        return `#${getUserColor(this.state.preGuestAnonymousId)}`;
      }
      return '#FFFFFF';
    }
    return `#${getUserColor(user.anonymous_id || user.id)}`;
  }
}
